import React, { useEffect } from 'react';
import HeroSection from './components/home/HeroSection';
import WhatIsASI1 from './components/home/WhatIsASI1';
import KeyFeatures from './components/home/KeyFeatures';
import ModelFamily from './components/home/ModelFamily';
import ModelSelection from './components/home/ModelSelection';
import BuildingWithASI1 from './components/home/BuildingWithASI1';
import PromptEngineering from './components/home/PromptEngineering';

const Home = () => {
  // Ensure scroll position is at the top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container mx-auto sm:px-6 md:px-4 sm:py-8 max-w-7xl" style={{ paddingLeft: '0.1rem', paddingRight: '0.1rem', paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
      <div className="bg-white rounded-lg shadow-lg overflow-hidden">
        <HeroSection />

        {/* Content sections */}
        <div className="px-6 md:px-12 lg:px-16 py-8">
          <WhatIsASI1 />
          <KeyFeatures />
          <ModelFamily />
          <ModelSelection />
          <BuildingWithASI1 />
          <PromptEngineering />
        </div>
      </div>
    </div>
  );
};

export default Home;
